import { OrganizationType } from "../enums/organizationTypes";

export interface AgenticAuthOnFileOrgTab {
  id: string;
  label: string;
}

/** Org tabs (NYCBS, CHC, MBP, UCBC) for Agentic Auth on File configuration. */
export const AGENTIC_AUTH_ON_FILE_ORG_TABS: AgenticAuthOnFileOrgTab[] = [
  { id: OrganizationType.NYCBS, label: "NYCBS" },
  { id: OrganizationType.CHC, label: "CHC" },
  { id: OrganizationType.MBP, label: "MBP" },
  { id: OrganizationType.UCBC, label: "UCBC" },
];
